import { Observable } from 'rxjs';
import { PusherConfigModel } from '../../models';

export abstract class AbstractPusherConfigService {
  abstract getConfig(): PusherConfigModel;

  abstract getAccessTokenAsync(): Promise<string>;
  abstract getChannelIdAsync(): Observable<string>;
}
